var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrawerSupportSvgrepoCom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    width: "800px",
    height: "800px",
    viewBox: "0 0 1000 1000",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#ffffff",
    strokeWidth: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M997 616q-6-69-30-106-24-40-70-46-29-79-88.5-140.5T669 229q-4-2-4-6.5t4-6.5q45-18 72-51t27-73q0-48-40-86-3-4-7.5-1.5T718 11q12 23 12 50 0 33-21 59-19 23-57 44-52 28-111 22-20-2-41-2-89 0-171 38-79 36-138 99.5T103 464q-46 6-70 46Q9 547 3 616q-7 78 22 116 26 34 82 37 38 70 111.5 115.5T384 938q8 1 11 7 6 12 17.5 18.5T437 970h101q19 0 33.5-14.5T586 921t-14-34.5-34-14.5H437q-13 0-24 6.5T396 896q-4 7-13 6-72-10-130.5-45.5T161 765q4-1 7-3 10-2 17.5-44t7.5-101q0-56-6.5-97T170 473q21-75 75-125t140-72q41-10 76-5 41 5 63 32 14 17 14 51 0 23-10 43-4 9 3 16t16 3q31-17 49.5-44.5T615 314q0-12-3.5-24t6-20.5T638 266q70 29 119.5 82.5T829 473q-7 10-11 50t-4 92q0 44 3 79.5t8 53.5q0 6 4 10l1 1q4 5 10 6 12 4 42 4 61 0 90-34 32-37 25-119zM584 758H418q-7 0-10.5 5.5T407 775q10 22 35.5 36.5t58 14.5 58.5-14.5 36-36.5q3-6-1-11.5t-10-5.5zM309 614q0 24 17 41t41 17 40.5-17 16.5-41-16.5-40.5T367 557t-41 16.5-17 40.5zm268 0q0 24 17 41t40.5 17 40.5-17 17-41-17-40.5-40.5-16.5-40.5 16.5-17 40.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawerSupportSvgrepoCom1);
export default __webpack_public_path__ + "static/media/drawer-support-svgrepo-com (1).06f988094c046a3bfa039feb37e27351.svg";
export { ForwardRef as ReactComponent };